// @ts-strict-ignore
import { inject, injectable } from "tsyringe";
import { WINDOW } from "@identity/symbols";

export enum FandomContextGroups {
  tracking = "tracking",
  page = "page",
  site = "site",
  partners = "partners",
  targeting = "targeting",
}

@injectable()
export class ContextRepository {
  constructor(@inject(WINDOW) private window: Window) {}

  public get<T extends keyof FandomContext, K extends keyof FandomContext[T]>(
    context: T,
    name: K,
  ): FandomContext[T][K] {
    return this.window.fandomContext[context][name];
  }

  public set<T extends keyof FandomContext, K extends keyof FandomContext[T]>(
    context: T,
    name: K,
    property: CookieProperty<FandomContext[T][K]>,
  ): void {
    if (!this.window.fandomContext || !this.window.fandomContext[context]) {
      this.window.fandomContext = {
        ...this.window.fandomContext,
        [context]: {},
      };
    }
    this.window.fandomContext[context][name] = property.value;
  }

  public remove<
    T extends keyof FandomContext,
    K extends keyof FandomContext[T],
  >(context: T, name: K) {
    try {
      delete this.window.fandomContext[context][name];
    } catch {
      // do nothing if there is nothing to delete
    }
  }
}
